<!--
 * @Descripttion: 数据报表、数据大屏组件
 * @Author: zenghua.wang
 * @Date: 2021-11-11 11:19:31
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-24 16:40:28
-->
<template>
  <section v-if="loading">
    <div
      v-for="(item, index) in data.list"
      :key="index"
    >
      <component
        :is="`drag-${item.type}`"
        :id="item.prop"
        :label="item.label"
        :apiId="item.apiId"
        :width="item.width"
        :height="item.height"
        :option="item.option"
        :page="item.page"
        :children="item.children"
        :index="index"
        :disabled="true"
      >
      </component>
    </div>
  </section>
</template>

<script>
/** 引入拖拽组件、属性设置组件 */
import '@/dragComponents/index.js'
import { isEmpty } from '@/dragComponents/utils'

export default {
  name: 'vue-data-report',
  provide() {
    return {
      category: this.$route.query.reportCategory || this.reportCategory,
      device: this.$route.query.reportDevice || this.reportDevice
    }
  },
  props: {
    // 报表模型id 必须
    reportId: {
      type: String
    },
    // 报表分类：report | screen
    reportCategory: {
      type: String,
      default: 'report'
    },
    // 报表展示设备：desktop | mobile
    reportDevice: {
      type: String,
      default: 'desktop'
    }
  },
  data() {
    return {
      loading: false,
      data: {}
    }
  },
  computed: {},
  methods: {
    loadData() {
      let id = this.$route.query.reportId
        ? this.$route.query.reportId
        : this.reportId
      if (isEmpty(id)) return
      this.$http
        .get(`/data-report/model/${id}`)
        .then((res) => {
          if (res.code === 200) {
            const modelJsonMap = res.data.modelJsonMap
            this.data = modelJsonMap
            this.loading = true
          }
        })
        .catch((err) => {
          this.$message && this.$message.error(err.msg)
          this.$toast && this.$toast.fail(err.msg)
        })
    }
  },
  created() {
    this.loadData()
  }
}
</script>
